/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { smoothScrollTo } from "./smoothScrollTo";
import { setMobileBtn } from "./setMobileBtn";
import { setScrollTrigger } from "./setScrollTrigger";
import { setModal } from "./setModal";
import { setSplash } from "./setSplash";
import { setMouseStalker, setMouseStalkerTransform } from "./setMouseStalker";
import { setAcdnMenu } from "./setAcdnMenu";
import { setHeaderTransform } from "./setHeaderTransform";
import './setSlider';
import './setScrollNavCurrent';

/**
 * Do modules.
 */
function modules() {
  smoothScrollTo();
  setSplash();
  setMobileBtn();
  setMouseStalker();
  setMouseStalkerTransform();
  setModal();
  setScrollTrigger();
  setAcdnMenu();
  setHeaderTransform();
}

export { modules };
